import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useDetectRefScroll } from "@faire/web--source/ui/hooks/useDetectScroll";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useEffect } from "react";
import { useState } from "react";
var ALL_VIEWPORTS_NAVIGATION_BLOCK_SIZE = 96;
export var useModalScrolling = function(hasImage) {
    var isMobile = useViewport().isMobile;
    var _useState = _sliced_to_array(useState(false), 2), showDivider = _useState[0], setShowDivider = _useState[1];
    var _useState1 = _sliced_to_array(useState(hasImage ? 0 : 1), 2), navigationOpacity = _useState1[0], setNavigationOpacity = _useState1[1];
    var _useDetectRefScroll = useDetectRefScroll("y", 0), scrollState = _useDetectRefScroll.scrollState, refCallBack = _useDetectRefScroll.refCallBack;
    useEffect(function() {
        setShowDivider(scrollState.scrollPosition > 0);
        setNavigationOpacity(hasImage && isMobile ? Math.min(Math.round(scrollState.scrollPosition / ALL_VIEWPORTS_NAVIGATION_BLOCK_SIZE * 100) / 100, 1) : 1);
    }, [
        hasImage,
        isMobile,
        scrollState,
        showDivider
    ]);
    return {
        showDivider: showDivider,
        navigationOpacity: navigationOpacity,
        refCallBack: refCallBack
    };
};
